import { EmployeesDataCollection } from 'modules/finance/components/Budgets/ExpenseBudgetDetailDataCollection/EmployeesDataCollection'

import { useExpenseBudgetDetailContext } from 'modules/finance/pages/ExpenseBudgetDetailPage'

const EmployeesTab = () => {
  const { budget, locale } = useExpenseBudgetDetailContext()
  return <EmployeesDataCollection budget={budget} locale={locale} />
}

export default EmployeesTab
